import { AccountDeletionReasonRowActions } from 'modules/crm/settings/account-deletion-reason/components/AccountDeletionReasonRowActions';
import { EditLink, HeadCell } from '@dfl/mui-admin-layout';
import { IAccountDeletionReason } from 'modules/crm/settings/account-deletion-reason/interfaces';
import { createdATColumn } from 'modules/common/constants/common.columns';
import { ACCOUNT_DELETION_REASON_PERMISSIONS } from 'modules/crm/settings/account-deletion-reason/constants/account-deletion-reason.permissions';

export const accountDeletionReasonNameColumn: HeadCell<IAccountDeletionReason> = {
  field: 'name',
  headerName: 'accountDeletionReason:fields.name',
  disablePadding: false,
  renderCell: (name: string, data?: IAccountDeletionReason) => (<EditLink entityId={data?._id as string}>{name}</EditLink>),
};

export const accountDeletionReasonDescriptionColumn: HeadCell<IAccountDeletionReason> = {
  field: 'description',
  headerName: 'accountDeletionReason:fields.description',
};

export const accountDeletionReasonActionsColumn: HeadCell<IAccountDeletionReason> = {
  field: 'actions',
  sortable: false,
  width: 100,
  permissions: ACCOUNT_DELETION_REASON_PERMISSIONS.ACCOUNT_DELETION_REASON_WRITE,
  headerName: 'common:actions',
  disablePadding: true,
  component: AccountDeletionReasonRowActions,
};

export const accountDeletionReasonColumns: Array<HeadCell<any>> = [
  accountDeletionReasonNameColumn,
  accountDeletionReasonDescriptionColumn,
  createdATColumn,
  accountDeletionReasonActionsColumn
];
